import { baseApi } from '@/lib/api/baseApi';

import type { Builder } from '../commonApiType/apiBuilderTypes';
import {
  chatbotDeleteParams,
  chatbotResponse,
  getChatbotParams,
  getChatbotResponse,
} from '../commonApiType/testOptimizeUserType';

export const chatbotApi = baseApi.injectEndpoints({
  endpoints: (builder: Builder) => ({
    chatbot: builder.mutation({
      query: payload => ({
        url: '/chatbotagent/predict',
        method: 'POST',
        body: payload,
      }),
    }),
    clearChatbot: builder.mutation<chatbotResponse, chatbotDeleteParams>({
      query: ({ licenseId, userId, sessionId }) => ({
        url: `/chatbotagent/delete-history/${licenseId}/${userId}/${sessionId}`,
        method: 'DELETE',
      }),
    }),
    getChatbot: builder.query<getChatbotResponse, getChatbotParams>({
      query: ({ licenseId, userId }) => ({
        url: `/chatbotagent/get-history/${licenseId}/${userId}`,
        method: 'GET',
      }),
    }),
  }),
});
